import { Link } from 'react-router-dom';
import {
  Fireplace,
  Lake,
  NewConstruction,
  Office,
  Parking,
  PetFriendly,
  Pool,
  ScenicViews,
  SmartHome,
  SolarPanels,
  Townhouse,
  Wifi,
} from '../../assets/icons';
import { PRIMARY_PROPERTY_LABELS, TOOLTIP_TEXT } from '../../utils/constant';

const tooltipData =
  'Lorem ipsum dolor sit amet consectetur adipiscing elit. Congue euismod elementum interdum viverra luctus faucibus egestas morbi.';


export const headerData = {
  market: 'Initial Offering',
  propertyName: 'The Wellington',
  isFavorite: true,
};

export const labelData = {
  label: 'Fully Funded',
  type: 'green',
};

export const cardData = {
  buyLabel: 'Buy',
  cardInfoData: [
    {
      /* CR-158 Hide funding bar and set Static Label */
      // label: 'Shares remaining',
      label: 'Estimated Dividend Yield',
      value: '$100',
      tooltip: TOOLTIP_TEXT.ESTIMATED_DIVIDEND_YIELD,
    },
    // Comment out for CR change to hide investor count
    // {
    //   label: 'Investors',
    //   value: '147',
    // },
    {
      label: PRIMARY_PROPERTY_LABELS.SHARE_PRICE,
      value: '$100',
      prefix: '$',
    },
    /* CR-158 Hide funding bar and set Static Label */
    {
      label: 'Shares Available',
      value: '',
      prefix: '',
    },
  ],
  fundingProgress: 60,
};

export const basicData = {
  basics: [
    {
      suffix: 'bedrooms',
      value: 'bed',
    },
    {
      suffix: 'baths',
      value: 'bath',
    },
    {
      suffix: 'Sq.Ft',
      value: 'sqFt',
    },
    {
      prefix: 'Built',
      value: 'yearBuild',
    },
  ],
  advance: [
    {
      label: 'Property type',
      value: 'propertyTypeName',
    },
    {
      label: 'Location',
      value: 'finance.purchasePrice',
    },
    {
      label: 'Purchase price',
      tooltip: tooltipData,
      value: '$1,234,567',
    },
    {
      label: 'Avg cost to rent',
      value: '$200/night',
    },
  ],
};

export const aboutData = {
  description:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Egestas dui, aliquet curabitur turpis amet, arcu blandit lectus. Eu eu, in mauris sed in fermentum ac. Lorem est ut sed leo adipiscing quam leo at. Eu nibh neque ipsum, nec praesent sapien, odio. Vivamus ut orci tempor morbi enim tempus tempus vulputate. Ut ut diam nibh odio at luctus eget odio. Eget ut a ut diam elementum pharetra amet. Eget facilisis egestas nunc arcu lacus amet. Nunc lobortis suspendisse magna commodo amet, in dolor. Eget nibh sem cursus imperdiet ac nam in. Egestas pulvinar eu habitant morbi leo, etiam sed.',
  amenities: [
    {
      icon: <Townhouse />,
      label: 'Townhouse',
    },
    {
      icon: <SolarPanels />,
      label: 'Solar panels',
    },
    {
      icon: <Pool />,
      label: 'Pool',
    },
    {
      icon: <NewConstruction />,
      label: 'New construction',
    },
    {
      icon: <PetFriendly />,
      label: 'Pet friendly',
    },
    {
      icon: <Fireplace />,
      label: 'Fireplace',
    },
    {
      icon: <SmartHome />,
      label: 'Smart home',
    },
    {
      icon: <Parking />,
      label: '2 Car garage',
    },
    {
      icon: <ScenicViews />,
      label: 'Scenic views',
    },
    {
      icon: <Lake />,
      label: 'Lake',
    },
    {
      icon: <Office />,
      label: 'Office',
    },
    {
      icon: <Wifi />,
      label: 'Wifi',
    },
  ],
};

export const manageData = {
  manageTitle: 'Property Management Partner',
  manageData: [
    {
      label: 'Property status',
      tooltip: TOOLTIP_TEXT.PROPERTY_STATUS,
      value: 'propertyStatus',
      map: {
        rentReady: 'Rent ready',
        rented: 'Rented',
        marketedForRent: 'Marketed for rent',
        underConstruction: 'Under Construction',
      },
    },
    {
      label: 'Occupancy rate',
      tooltip: TOOLTIP_TEXT.OCCUPANCY_RATE,
      value: 'occupancyRate',
      suffix: '%',
    },
    {
      label: 'Estimated dividend yield',
      tooltip: TOOLTIP_TEXT.ESTIMATED_DIVIDEND_YIELD,
      value: 'dividendYield',
      suffix: '% per year',
    },
  ],
  processTitle: 'Pacaso Second Homes',
  processDescription: (
    <p>
      Pacaso is a property broker that buys single-family homes and sells them to consortiums of buyers. The San Francisco–based company claims it
      reached unicorn status faster than any other USA-based company.{' '}
      <Link className='fw-600 underline text-terracotta' to='/not-found/'>
        Learn more
      </Link>{' '}
    </p>
  ),
};

export const manageDataRented = {
  manageTitle: 'Property Management Partner',
  manageData: [
    {
      label: 'Property status',
      tooltip: TOOLTIP_TEXT.PROPERTY_STATUS_RENTED,
      value: 'propertyStatus',
      map: {
        rentReady: 'Rent ready',
        rented: 'Rented',
        marketedForRent: 'Marketed for rent',
        underConstruction: 'Under Construction',
      },
    },
    {
      label: 'Occupancy rate',
      tooltip: TOOLTIP_TEXT.OCCUPANCY_RATE,
      value: 'occupancyRate',
      suffix: '%',
    },
    {
      label: 'Estimated dividend yield',
      tooltip: TOOLTIP_TEXT.ESTIMATED_DIVIDEND_YIELD,
      value: 'dividendYield',
      suffix: '% per year',
    },
  ],
  processTitle: 'Pacaso Second Homes',
  processDescription: (
    <p>
      Pacaso is a property broker that buys single-family homes and sells them to consortiums of buyers. The San Francisco–based company claims it
      reached unicorn status faster than any other USA-based company.{' '}
      <Link className='fw-600 underline text-terracotta' to='/not-found/'>
        Learn more
      </Link>{' '}
    </p>
  ),
};

export const marketData = {
  location: 'Downtown Portland',
  description: (
    <>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Congue euismod elementum interdum viverra luctus faucibus egestas morbi. Ipsum velit,
        nibh posuere dignissim. Congue euismod elementum interdum viverra luctus faucibus egestas morbi.Urna, arcu amet pellentesque semper.
      </p>

      <p>
        Congue euismod elementum interdum viverra luctus faucibus egestas morbi.Urna, arcu amet pellentesque semper. Lorem ipsum dolor sit amet,
        consectetur adipiscing elit. Congue euismod elementum interdum viverra luctus faucibus egestas morbi. Ipsum velit, nibh posuere dignissim.{' '}
      </p>
    </>
  ),
  address: '234 SW Main St, Portland OR, 01119',
  addressLink: 'https://goo.gl/maps/2aHWQPQ7HiuE1Vrs6',
  mapLink:
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d72.4993674247736!2d23.028114900693655!3d34.087168!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x54950a0fc618ffd3%3A0xfb55e7e2263a231f!2s234%20SW%20Main%20St%2C%20Portland%2C%20OR%2097204%2C%20USA!5e0!3m2!1sen!2sin!4v1672640584558!5m2!1sen!2sin',
  grade: 'B',
  score: 68,
  parameters: [
    {
      label: 'Rental demand',
      tooltip: TOOLTIP_TEXT.RENTAL_DEMAND,
      value: 84,
    },
    {
      label: 'Revenue growth',
      tooltip: TOOLTIP_TEXT.REVENUE_GROWTH,
      value: 43,
    },
    {
      label: 'Seasonality',
      tooltip: TOOLTIP_TEXT.SEASONALITY,
      value: 72,
    },
    {
      label: 'Regulation',
      tooltip: TOOLTIP_TEXT.REGULATION,
      value: 33,
    },
    {
      label: 'Investibility',
      tooltip: TOOLTIP_TEXT.INVESTIBILITY,
      value: 33,
    },
  ],
};

export const offeringData = {
  details: [
    {
      label: 'Mortgage amount',
      tooltip: TOOLTIP_TEXT.MORTGAGE_AMOUNT,
      value: 'mortgageAmount',
      prefix: '$',
    },
    {
      label: 'Mortgage interest rate',
      tooltip: TOOLTIP_TEXT.MORTGAGE_INTREST_RATE,
      value: 'mortgageInterestRate',
      suffix: '%',
    },
    {
      label: 'Equity raised',
      value: 'equityRaised',
      prefix: '$',
    },
    {
      label: 'Initial Offering Price',
      value: 'perSharePrice',
      prefix: '$',
    },
    {
      label: 'Total Shares',
      value: 'totalShare',
    },
    {
      label: 'Shares Remaining',
      value: 'sharesRemaining'
  },
    {
      label: 'Leverage',
      tooltip: TOOLTIP_TEXT.LEVERAGE,
      value: 'leverage',
      suffix: '%',
    },
  ],
  rating: 'medium',
  expanses: [
    {
      label: 'Purchase price',
      tooltip: TOOLTIP_TEXT.OFFERING_PURCHASE_PRICE,
      amount: 'purchasePrice',
      prefix: '$',
    },
    {
      label: 'Improvements',
      tooltip: TOOLTIP_TEXT.IMPROVEMENTS,
      amount: 'improvements',
      prefix: '$',
    },
    {
      label: 'Closing, offering & holding costs',
      tooltip: TOOLTIP_TEXT.CLOSING_OFFERING_HOLDING_COSTS,
      amount: 'cohCosts',
      prefix: '$',
    },
    {
      label: 'Realbricks sourcing fee',
      tooltip: TOOLTIP_TEXT.RB_SOURCING_FEE,
      amount: 'sourcingFees',
      prefix: '$',
    },
  ],
  fees: [
    {
      name: 'Assets Under Management (AUM)  Fee (Quarterly)',
      amount: 'aumFees',
      prefix: '$',
      tooltip: TOOLTIP_TEXT.RB__AUM_QUARTER,
      points: [{ aumPurchasePriceFees: (val) => `${val} AUM fee` }],
    },
    {
      name: 'Property Management Fee (Monthly)',
      amount: 'aumFees',
      prefix: '$',
      tooltip: TOOLTIP_TEXT.RB__AUM_MONTHLY,
      points: [
        {
          propertyMgmtFeesMin: (val) => `${val} of monthly gross rental revenue`,
        },
      ],
    },
  ],
  documents: [
    {
      name: 'Use of proceeds',
      link: '/not-found/',
    },
    {
      name: 'Risk factors',
      link: '/not-found/',
    },
    {
      name: 'Series overview',
      link: '/not-found/',
    },
    {
      name: 'Offering circular',
      link: '/not-found/',
    },
  ],
};

const answer =
  'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Eget aliquet sit dictumst nulla interdum. Viverra elit mattis donec sed. Integer viverra metus cras nibh etiam. Amet fusce arcu tellus sit.';

export const faqData = {
  faqData: [
    {
      question: 'Lorem ipsum dolor sit amet?',
      answer: answer,
    },
    {
      question: 'Consectetur adipiscing elit?',
      answer: answer,
    },
    {
      question: 'Eget aliquet sit dictumst nulla interdum?',
      answer: answer,
    },
    {
      question: 'Viverra elit mattis donec sed?',
      answer: answer,
    },
    {
      question: 'Integer viverra metus cras nibh etiam?',
      answer: answer,
    },
  ],
};
